import { Card, CardContent, Checkbox, Dialog, DialogActions, DialogContent, FormControlLabel, Grid, Link, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import AppBarModal from '../../general/AppBarModal'
import { BtnForm } from '../../general/BotonesAccion'
import file from '../../../global/imagenes/file.png';
import { makeStyles } from '@material-ui/core/styles';
import { obtenerPermisosValorAlt } from '../../../global/js/funciones'
import { DOCUMENTOS_INFORMATIVOS } from '../helper';

const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: "100%",
    minHeight: "50px",
    height: "200px",
  },
  image: {
    width: '100px',
    maxWidth: '100px',
    minWidth: '100px',
    height: "100px",
  },
  content_img: {
    marginTop: '10px',
    textAlign: 'center',
    height: "100px",
  },
  title:{
    fontSize: '14px',
    height: "40px"
  }
}));

export const ModalPoliticaDatos = (props) => {
    const { openModalPolitica, closeModalPolitica, openModalNuevo, setPoliticaPrivacidad, setPoliticaTrataDatos, politica_privacidad, tratamiento_datos } = props
    const classes = useStyles();

    const [politicas, setPoliticas] = useState([]);

    useEffect(() => {
        const fetchPoliticas = async () => {
          try {
            let politicas = (await obtenerPermisosValorAlt([
              { 'llave': 'principal__codigo', 'valor': 'portal_act' },
              { 'llave': 'secundario__generica', 'valor': DOCUMENTOS_INFORMATIVOS }
            ])).map(({ secundario }) => secundario);
      
            politicas = politicas.filter((item) => item.codigo === 'pol_tra_dat_per' || item.codigo === 'pol_pri');
            setPoliticas(politicas);
          } catch (error) {
            console.error('Error al obtener políticas:', error);
          }
        };
      
        fetchPoliticas();
      }, []);
      
    
    return (
        <Dialog open={openModalPolitica} onClose={closeModalPolitica} fullWidth={true} maxWidth="sm">
            <AppBarModal titulo={'Politica de datos'} mostrarModal={closeModalPolitica} titulo_accion="" accion="" />
            <DialogContent className='scroll'>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '10px', marginBottom: '10px' }}>
                    <p style={{ fontSize: 14, color: '#000' }}>
                        Al aceptar la política de tratamiento de datos, autorizas a la empresa a utilizar los datos personales que proporciones con fines exclusivamente relacionados con el proceso de selección.
                        <br /><br />
                        <strong style={{ color: 'red' }}>No olvides hacer clic en el botón "ACEPTAR" para confirmar tu consentimiento.</strong>
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                    {politicas.length > 0 && politicas.map((politica) => {
                        return (
                            <Link key={politica.codigo} href={politica.archivo} target="_blank" underline='none' style={{ width: '50%'}}>
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Grid container direction={'row'} justifyContent={'center'}>
                                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                {politica.nombre}
                                            </Typography>
                                            <Grid item xs={12} sm={12} md={12} className={classes.content_img}>
                                                <img src={file} className={classes.image} alt='Imagen Tipo' />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Link>
                        )                        
                    })}
                    </div>
                </div>
                <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={politica_privacidad || false}
                        onChange={setPoliticaPrivacidad}
                        color="primary"
                        />
                    }
                    label={<Typography variant="body2">Autorizo el tratamiento de los datos diligenciados según las políticas de privacidad.</Typography>}
                    />
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={tratamiento_datos || false}
                        onChange={setPoliticaTrataDatos}
                        color="primary"
                        />
                    }
                    label={<Typography variant="body2">Autorizo el tratamiento de los datos diligenciados según las politicas de tratamiento de datos personales.</Typography>}
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <BtnForm texto="ACEPTAR" callback={openModalNuevo} type="submit" />
            </DialogActions>
        </Dialog>
    )
}
